import { render, staticRenderFns } from "./ga.vue?vue&type=template&id=1cfdf80b&"
import script from "./ga.vue?vue&type=script&lang=js&"
export * from "./ga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports